import {cloneDeep, merge} from 'lodash';

import {DeepPartial} from '../../../../core/src/helpers/typescript/typeHelpers';
import {borderRadiusPrimitive} from '../../styles/primitives/borderRadiusPrimitive';
import {spacingPrimitive} from '../../styles/primitives/spacingPrimitive';
import {expandedDarkAppFrameSemanticStyles} from '../semantic/appFrameSemanticStyles';
import {expandedLeftBarSemanticStyles} from '../semantic/leftBarSemanticStyles';
import {themeConstants} from '../themeConstants';
import {ThemeTypesEnum, UserTheme} from '../themeTypes';
import {darkColors} from './darkColors';
import {darkSemanticStyles} from './darkSemanticStyles';

export const darkTheme: UserTheme = {
  ...darkSemanticStyles,
  ...darkColors,
  constants: themeConstants,
  spacing: spacingPrimitive,
  borderRadius: borderRadiusPrimitive,
  type: ThemeTypesEnum.DARK,
  hasInboxRedesign: false,
  hasDropdownRedesign: false,
  hasP0AppSwitcher: false,
};

const expandedDarkThemeStyles: DeepPartial<UserTheme> = {
  leftBar: expandedLeftBarSemanticStyles,
  appFrame: expandedDarkAppFrameSemanticStyles,
};

// Expanded P2/P3 dark mode styles, including dark banner styles and the new sidebar.
export const expandedDarkTheme: UserTheme = merge(
  {
    ...cloneDeep(darkTheme),
    type: ThemeTypesEnum.EXPANDED_DARK,
  },
  expandedDarkThemeStyles,
);

export const darkSidebarTheme: UserTheme = {
  ...expandedDarkTheme,
  type: ThemeTypesEnum.DARK_SIDEBAR,
};
